import { useCallback } from "react";
import { useValueRef } from "./useValueRef.js";

/**
 * Implements useEffectEvent for React 18. Example code
 * taken from: https://github.com/sanity-io/use-effect-event/blob/main/src/useEffectEvent.ts
 */
export const useEffectEvent = <F extends (...args: any) => void>(fn: (...input: Parameters<F>) => void) => {
  const ref = useValueRef(fn);
  return useCallback((...input: Parameters<F>) => ref.current(...input), [ref]);
};
